(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["leivas-subscription-journey"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CX = 1120, CY = 436, R = 214;

    function hexToRgb(h) {
      if (!h) return [198, 161, 91];
      h = String(h).trim().replace('#', '');
      if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      var n = parseInt(h, 16);
      if (isNaN(n)) return [198, 161, 91];
      return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
    }

    function build(root) {
      if (root.__subsStory) return root.__subsStory;
      var q = function (s) { return root.querySelector(s); };
      var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
      var st = {
        root: root,
        sticky: q('[data-story-sticky]'),
        svg: q('[data-story-svg]'),
        bar: q('[data-story-bar]'),
        rail: q('[data-story-rail]'),
        halo: q('[data-halo]'),
        guide: q('[data-guide]'),
        segs: qa('[data-seg]'),
        segLabels: qa('[data-seglabel]'),
        visit: q('[data-visit]'),
        hbean: q('[data-hbean]'),
        quarters: qa('[data-quarter]'),
        weeknum: q('[data-weeknum]'),
        plate: q('[data-plate]'),
        plateImg: qa('[data-plateimg]'),
        plateCap: q('[data-platecap]'),
        mileDot: qa('[data-miledot]'),
        mileRip: qa('[data-mile]').map(function (g) {
          return Array.prototype.slice.call(g.querySelectorAll('[data-ripple]'));
        }),
        mileLine: qa('[data-mileline]'),
        mileText: qa('[data-miletext]'),
        dialwrap: q('[data-dialwrap]'),
        dial: q('[data-dial]'),
        ticks: q('[data-ticks]'),
        prog: q('[data-prog]'),
        dialtype: q('[data-dialtype]'),
        marker: q('[data-marker]'),
        stageC: q('[data-stage-c]'),
        route: q('[data-route]'),
        miles: q('[data-miles]'),
        mile: qa('[data-mile]'),
        arrive: q('[data-arrive]'),
        arrive2: q('[data-arrive2]'),
        fin: q('[data-final]'),
        ctag: q('[data-ctag]'),
        cup: q('[data-cup]'),
        seed: q('[data-seed]'),
        cupImg: q('[data-cupimg]'),
        steam: q('[data-steam]'),
        wisps: qa('[data-wisp]'),
        finType: q('[data-finaltype]'),
        beans: qa('[data-bean]'),
        eyebrows: qa('[data-eyebrow]'),
        mplate: q('[data-mplate]'),
        mctag: q('[data-mctag]'),
        c1: q('[data-copy="1"]'),
        c2: q('[data-copy="2"]'),
        c3: q('[data-copy="3"]'),
        gold: root.getAttribute('data-gold') || '#C6A15B',
        goldInk: root.getAttribute('data-gold-ink') || '#8A6E42',
        caps: qa('[data-plateimg]').map(function (im) { return im.getAttribute('data-cap') || ''; })
      };
      st.routeD = st.route ? st.route.getAttribute('d') : '';
      st.routeLen = st.route ? st.route.getTotalLength() : 1;
      st.portrait = null;
      applyLayout(st);
      st.goldRgb = hexToRgb(st.gold);
      st.goldInkRgb = hexToRgb(st.goldInk);
      root.__subsStory = st;
      return st;
    }


    var ROUTE_M = 'M800,742 C900,706 1000,806 1120,762 C1230,722 1330,806 1440,772';

    function applyLayout(st) {
      var want = window.innerWidth < 900;
      if (st.portrait === want) return;
      st.portrait = want;
      if (st.route) {
        st.route.setAttribute('d', want ? ROUTE_M : st.routeD);
        st.routeLen = st.route.getTotalLength();
        st.milePts = null;
      }
      if (st.miles) {
        st.miles.setAttribute('font-size', want ? '19' : '13');
        st.miles.setAttribute('letter-spacing', want ? '1.5' : '5');
      }
      if (st.plateCap) st.plateCap.style.display = want ? 'none' : '';
      if (st.mplate) st.mplate.setAttribute('transform', want ? 'translate(1152,336) scale(0.82) translate(-1152,-336) translate(-40,224)' : '');
      if (st.mctag) st.mctag.setAttribute('transform', want ? 'translate(800,672) scale(1.55) translate(-800,-672)' : '');
      if (!want && st.svg) {
        st.svg.setAttribute('viewBox', '0 0 1600 900');
        st.svg.style.top = '';
        st.svg.style.height = '';
      }
    }

    var CAM = [
      [0.00, 800, 116, 640, 640],
      [0.68, 800, 116, 640, 640],
      [0.77, 740, 420, 760, 500],
      [0.88, 740, 420, 760, 500],
      [0.945, 445, 95, 710, 720],
      [1.00, 445, 95, 710, 720]
    ];

    function camera(st, p) {
      if (!st.portrait || !st.svg) return;
      var a = CAM[0], b = CAM[CAM.length - 1], i;
      for (i = 0; i < CAM.length - 1; i++) {
        if (p >= CAM[i][0] && p <= CAM[i + 1][0]) { a = CAM[i]; b = CAM[i + 1]; break; }
      }
      var span = b[0] - a[0];
      var t = span > 0 ? (p - a[0]) / span : 0;
      t = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      var v = [];
      for (i = 1; i < 5; i++) v.push(a[i] + (b[i] - a[i]) * t);
      st.svg.setAttribute('viewBox', v.map(function (n) { return n.toFixed(1); }).join(' '));

      var band = 27 * (1 - Math.min(1, Math.max(0, (p - 0.895) / 0.05)));
      var w = st.root.clientWidth || window.innerWidth;
      var vh = st.sticky ? st.sticky.clientHeight : window.innerHeight;
      var artH = w * (v[3] / v[2]);
      var bandPx = vh * band / 100;
      var slack = Math.max(0, vh - bandPx - artH);
      st.svg.style.top = (bandPx + slack * (band > 0 ? 0.1 : 0.5)).toFixed(1) + 'px';
      st.svg.style.height = artH.toFixed(1) + 'px';
    }

    function tick(st) {
      if (!st || !document.contains(st.root)) return;
      var cl = function (v, a, b) { return v < a ? a : v > b ? b : v; };
      var sg = function (p, a, b) { return cl((p - a) / (b - a), 0, 1); };
      var ez = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
      var eo = function (t) { return 1 - Math.pow(1 - t, 3); };
      var lp = function (a, b, t) { return a + (b - a) * t; };
      var mix = function (x, y, t) {
        return 'rgb(' + x.map(function (v, i) { return Math.round(lp(v, y[i], t)); }).join(',') + ')';
      };
      var set = function (el, o, tr) {
        if (!el) return;
        el.style.opacity = String(o);
        if (tr !== undefined) el.style.transform = tr;
      };
      var dash = function (el, t) { if (el) el.style.strokeDashoffset = String(1 - t); };
      var pol = function (r, a) {
        var t = (a - 90) * Math.PI / 180;
        return [CX + r * Math.cos(t), CY + r * Math.sin(t)];
      };
      var arcD = function (r, a0, a1) {
        var span = Math.min(Math.abs(a1 - a0), 359.99);
        var mid = a0 + span / 2, end = a0 + span;
        var s = pol(r, a0), m = pol(r, mid), e = pol(r, end);
        return 'M' + s[0].toFixed(2) + ' ' + s[1].toFixed(2) +
          ' A' + r + ' ' + r + ' 0 0 1 ' + m[0].toFixed(2) + ' ' + m[1].toFixed(2) +
          ' A' + r + ' ' + r + ' 0 0 1 ' + e[0].toFixed(2) + ' ' + e[1].toFixed(2);
      };

      var now = performance.now() / 1000;
      var fl = function (spd, amp, ph2) { return Math.sin(now * spd + (ph2 || 0)) * amp; };
      var total = st.root.offsetHeight - window.innerHeight;
      var p = total > 0 ? cl(-st.root.getBoundingClientRect().top / total, 0, 1) : 0;
      if (st.bar) st.bar.style.width = (p * 100).toFixed(2) + '%';
      camera(st, p);

      var GOLD = st.gold;

      var clearOut = sg(p, 0.6, 0.72);
      set(st.halo, 0.9 * (1 - clearOut));
      set(st.guide, 0.18 * (1 - clearOut));
      dash(st.guide, 1);

      var segOut = sg(p, 0.4, 0.475);
      st.segs.forEach(function (el) { dash(el, 1); });

      var stops = [[240, 346], [360, 466], [480, 586]];
      var tour = [2, 0, 1];
      var ph = sg(p, 0.045, 0.375);
      var a0, a1, act, u0;
      if (ph < 0.2) { a0 = stops[0][0]; a1 = stops[0][1]; act = 0; }
      else if (ph < 0.38) {
        u0 = ez((ph - 0.2) / 0.18);
        a0 = lp(stops[0][0], stops[1][0], u0);
        a1 = lp(stops[0][1], stops[1][1], u0);
        act = u0 < 0.5 ? 0 : 1;
      } else if (ph < 0.58) { a0 = stops[1][0]; a1 = stops[1][1]; act = 1; }
      else if (ph < 0.76) {
        u0 = ez((ph - 0.58) / 0.18);
        a0 = lp(stops[1][0], stops[2][0], u0);
        a1 = lp(stops[1][1], stops[2][1], u0);
        act = u0 < 0.5 ? 1 : 2;
      } else { a0 = stops[2][0]; a1 = stops[2][1]; act = 2; }

      var closeRing = ez(sg(p, 0.395, 0.5));
      a1 = lp(a1, a0 + 359.99, closeRing);
      if (st.visit) {
        st.visit.setAttribute('d', arcD(R, a0, a1));
        st.visit.style.strokeWidth = String(lp(9, 3, closeRing));
        st.visit.style.transformOrigin = CX + 'px ' + CY + 'px';
        st.visit.style.transformBox = 'view-box';
      }

      var activeSeg = tour[act];

      if (st.hbean) {
        var mids = stops.map(function (s) { return (s[0] + s[1]) / 2; });
        var from, to, tw;
        if (ph < 0.2) { from = 0; to = 0; tw = 0; }
        else if (ph < 0.38) { from = 0; to = 1; tw = ez((ph - 0.2) / 0.18); }
        else if (ph < 0.58) { from = 1; to = 1; tw = 0; }
        else if (ph < 0.76) { from = 1; to = 2; tw = ez((ph - 0.58) / 0.18); }
        else { from = 2; to = 2; tw = 0; }
        var out = ez(cl(ph / 0.09, 0, 1));
        var target = lp(mids[from], mids[to], tw);
        var swing = Math.sin(tw * Math.PI);
        var bpt = pol(lp(0, 132, out) * (1 - 0.16 * swing), target);
        var bdrift = fl(0.62, 13, 0.4), bdrift2 = fl(0.47, 10, 1.9);
        var breath = 1 + 0.03 * Math.sin(now * 0.44);
        st.hbean.setAttribute('transform',
          'translate(' + (bpt[0] + bdrift2).toFixed(1) + ',' + (bpt[1] + bdrift).toFixed(1) + ') ' +
          'rotate(' + (-8 + fl(0.35, 3.5, 1.1)).toFixed(1) + ') ' +
          'scale(' + breath.toFixed(3) + ')');
        var TONES = [[1.24, 0.86], [1.0, 1.0], [0.72, 1.16]];
        var tf = TONES[tour[from]] || [1, 1], tt = TONES[tour[to]] || [1, 1];
        var tb = lp(1, lp(tf[0], tt[0], tw), out), tsat = lp(1, lp(tf[1], tt[1], tw), out);
        st.hbean.style.filter = 'brightness(' + tb.toFixed(3) + ') saturate(' + tsat.toFixed(3) + ')';
        st.hbean.style.opacity = String(1 - sg(p, 0.4, 0.475));
      }

      st.segs.forEach(function (el, i) {
        var on = i === activeSeg && ph > 0;
        el.style.strokeWidth = String(on ? 2.5 : 1.5);
        el.style.opacity = String(lp(1, on ? 0.9 : 0.16, sg(p, 0.17, 0.22)) * (1 - segOut));
      });
      st.segLabels.forEach(function (el, i) {
        var on = i === activeSeg && ph > 0;
        el.style.opacity = String((ph > 0 ? (on ? 1 : 0.2) : 1) * (1 - sg(p, 0.385, 0.455)));
        el.setAttribute('fill', on ? GOLD : 'currentColor');
        el.style.fontWeight = on ? '700' : '400';
      });

      set(st.dialwrap, 1);
      set(st.dial, 0);
      set(st.ticks, sg(p, 0.455, 0.515));
      set(st.dialtype, sg(p, 0.485, 0.545) * (1 - sg(p, 0.7, 0.755)),
        'scale(' + lp(0.94, 1, ez(sg(p, 0.485, 0.545))).toFixed(3) + ')');
      if (st.dialtype) {
        st.dialtype.style.transformOrigin = CX + 'px ' + CY + 'px';
        st.dialtype.style.transformBox = 'view-box';
      }

      var qp = sg(p, 0.545, 0.715);
      var k = Math.min(3, Math.floor(qp * 4));
      var within = cl((qp * 4 - k) / 0.62, 0, 1);
      var frac = cl((k + ez(within)) / 4, 0, 1);
      var weeks = Math.max(1, Math.min(4, Math.ceil(frac * 4 - 0.001) || 1));
      if (st.weeknum && st.weeknum.textContent !== String(weeks)) st.weeknum.textContent = String(weeks);
      dash(st.prog, frac);
      set(st.prog, sg(p, 0.485, 0.535));
      st.quarters.forEach(function (el, i) {
        var passed = frac >= (i + 1) / 4 - 0.012;
        el.setAttribute('fill', passed ? GOLD : 'currentColor');
        el.setAttribute('r', String(passed ? 7 : 4));
        el.style.opacity = String(sg(p, 0.47, 0.53) * (passed ? 1 : 0.3));
      });

      var ang = (-90 + 360 * frac) * Math.PI / 180;
      var onRing = { x: CX + R * Math.cos(ang), y: CY + R * Math.sin(ang) };

      var leave = ez(sg(p, 0.715, 0.815));
      set(st.stageC, sg(p, 0.705, 0.765));
      dash(st.route, ez(sg(p, 0.725, 0.845)));
      var routeDraw = ez(sg(p, 0.725, 0.845));
      set(st.miles, sg(p, 0.73, 0.78));
      var dialOut = sg(p, 0.7, 0.762);
      set(st.dialwrap, 1 - dialOut, 'scale(' + lp(1, 0.82, ez(dialOut)).toFixed(3) + ')');
      if (st.visit) {
        st.visit.style.transform = 'scale(' + lp(1, 0.82, ez(dialOut)).toFixed(3) + ')';
        st.visit.style.opacity = String(lp(1, 0.42, closeRing) * (1 - dialOut));
      }
      if (st.dialwrap) {
        st.dialwrap.style.transformOrigin = CX + 'px ' + CY + 'px';
        st.dialwrap.style.transformBox = 'view-box';
      }
      set(st.ticks, sg(p, 0.455, 0.515) * (1 - dialOut));
      set(st.prog, sg(p, 0.485, 0.535) * (1 - dialOut));
      st.quarters.forEach(function (el) {
        el.style.opacity = String(Number(el.style.opacity) * (1 - dialOut));
      });

      var cOutEarly = sg(p, 0.893, 0.936);
      var rl = st.routeLen || 1;
      var mt = st.portrait ? [0.14, 0.5, 0.86] : [0.06, 0.5, 0.95];
      var u = sg(p, 0.775, 0.888);
      var legs = [
        [0.0, 0.11, 0.02, mt[0]], [0.11, 0.27, mt[0], mt[0]],
        [0.27, 0.45, mt[0], mt[1]], [0.45, 0.61, mt[1], mt[1]],
        [0.61, 0.83, mt[1], mt[2]], [0.83, 1.01, mt[2], mt[2]]
      ];
      var tPos = 0.02;
      for (var li = 0; li < legs.length; li++) {
        var lg = legs[li];
        if (u >= lg[0] && u < lg[1]) {
          tPos = lg[2] === lg[3] ? lg[2] : lp(lg[2], lg[3], ez((u - lg[0]) / (lg[1] - lg[0])));
          break;
        }
      }
      if (u >= 1) tPos = mt[2];
      var arriveU = [0.11, 0.45, 0.83];
      var mx = onRing.x, my = onRing.y;
      if (st.route) {
        var pt = st.route.getPointAtLength(rl * tPos);
        var startPt = st.route.getPointAtLength(rl * 0.02);
        var tgt = leave > 0 ? pt : startPt;
        var cxp = lp(onRing.x, tgt.x, 0.32), cyp = lp(onRing.y, tgt.y, 0.92);
        var it = leave, om = 1 - it;
        mx = om * om * onRing.x + 2 * om * it * cxp + it * it * tgt.x;
        my = om * om * onRing.y + 2 * om * it * cyp + it * it * tgt.y;
        if (!st.milePts) {
          st.milePts = mt.map(function (t) { return st.route.getPointAtLength(rl * t); });
          st.milePts.forEach(function (q2, i) {
            if (st.mile[i]) st.mile[i].setAttribute('transform', 'translate(' + q2.x.toFixed(1) + ',' + q2.y.toFixed(1) + ')');
          });
        }
        mt.forEach(function (t, i) {
          var hit = ez(cl((u - (arriveU[i] - 0.055)) / 0.075, 0, 1));
          if (st.mile[i]) st.mile[i].style.opacity = String(cl((routeDraw - t + 0.06) / 0.1, 0, 1));
          var rip = cl((u - arriveU[i]) / 0.2, 0, 1);
          (st.mileRip[i] || []).forEach(function (c, j) {
            var rt = cl((rip - j * 0.22) / 0.78, 0, 1);
            c.setAttribute('r', String(lp(6, 62 - j * 14, eo(rt))));
            c.style.opacity = String(rt > 0 && rt < 1 ? (1 - rt) * (0.75 - j * 0.25) : 0);
          });
          if (st.mileDot[i]) {
            st.mileDot[i].setAttribute('fill', hit > 0.5 ? GOLD : 'currentColor');
            st.mileDot[i].setAttribute('r', String(lp(4.5, 8 + fl(1.05, 0.7, i * 1.7), hit)));
            st.mileDot[i].style.opacity = String(lp(0.45, 1, hit));
          }
          if (st.mileLine[i]) {
            st.mileLine[i].setAttribute('stroke', hit > 0.5 ? GOLD : 'currentColor');
            st.mileLine[i].setAttribute('y2', String(lp(-26, -38, hit)));
            st.mileLine[i].style.opacity = String(lp(0.4, 1, hit));
          }
          if (st.mileText[i]) {
            st.mileText[i].setAttribute('fill', hit > 0.5 ? GOLD : 'currentColor');
            st.mileText[i].setAttribute('y', String(lp(-40, -52, hit)));
            st.mileText[i].style.opacity = String(lp(0.42, 1, hit));
            st.mileText[i].style.fontWeight = hit > 0.5 ? '700' : '400';
          }
        });
      }

      if (st.plate) {
        var bounds = [arriveU[0] - 0.07, arriveU[1] - 0.07, arriveU[2] - 0.07, 2];
        var active = 0;
        st.plateImg.forEach(function (im, i) {
          var inW = cl((u - bounds[i]) / 0.06, 0, 1);
          var outW = 1 - cl((u - bounds[i + 1]) / 0.06, 0, 1);
          var wgt = inW * outW;
          im.style.opacity = String(wgt * 0.94);
          if (wgt > 0.5) active = i;
        });
        if (st.plateCap && st.caps[active] && st.plateCap.textContent !== st.caps[active]) {
          st.plateCap.textContent = st.caps[active];
        }
        var pin = sg(p, 0.775, 0.838);
        st.plate.style.opacity = String(pin * (1 - cOutEarly));
        st.plate.style.transformOrigin = '1152px 336px';
        st.plate.style.transformBox = 'view-box';
        st.plate.style.transform = 'translate(' + fl(0.42, 5).toFixed(2) + 'px,' + fl(0.55, 7, 0.8).toFixed(2) + 'px) scale(' + (lp(0.94, 1, ez(pin)) * (1 + fl(0.33, 0.006, 2.1))).toFixed(4) + ')';
      }

      if (st.marker) {
        st.marker.style.transformBox = 'fill-box';
        st.marker.style.transformOrigin = '50% 50%';
      }
      var pulse = 1;
      arriveU.forEach(function (au) {
        var q3 = cl((u - au) / 0.13, 0, 1);
        if (q3 > 0 && q3 < 1) pulse = Math.max(pulse, 1 + 0.28 * Math.sin(q3 * Math.PI));
      });
      var mdrift = sg(p, 0.7, 0.8);
      var fx = fl(0.85, 2.6) * mdrift, fy = fl(1.15, 3.6, 1.3) * mdrift;
      set(st.marker, sg(p, 0.52, 0.58),
        'translate(' + (mx - CX + fx).toFixed(1) + 'px,' + (my - (CY - R) + fy).toFixed(1) + 'px) scale(' + (pulse * lp(1, 1.15, ez(sg(p, 0.865, 0.9)))).toFixed(3) + ')');

      [st.arrive, st.arrive2].forEach(function (el, i) {
        if (!el) return;
        var t = sg(p, 0.864 + i * 0.018, 0.916 + i * 0.018);
        el.setAttribute('cx', mx.toFixed(1));
        el.setAttribute('cy', my.toFixed(1));
        el.setAttribute('r', String(lp(11, 86 + i * 34, eo(t))));
        el.style.opacity = String(t > 0 ? (1 - t) * 0.85 : 0);
      });

      var cOut = sg(p, 0.893, 0.936);
      if (st.stageC) st.stageC.style.opacity = String(sg(p, 0.715, 0.765) * (1 - cOut));
      if (st.marker) st.marker.style.opacity = String(sg(p, 0.52, 0.58) * (1 - sg(p, 0.898, 0.918)));

      var morph = ez(sg(p, 0.898, 0.952));
      set(st.fin, sg(p, 0.893, 0.906));
      if (st.fin) {
        st.fin.style.transformBox = 'view-box';
        st.fin.style.transform = 'translateY(75px)';
      }
      if (st.cup && st.route) {
        var endPt = st.route.getPointAtLength((st.routeLen || 1) * (st.portrait ? 0.86 : 0.95));
        var s0 = 11 / 74;
        var sc2 = lp(s0, 1, morph);
        var dx = lp(endPt.x - 800, 0, morph), dy = lp(endPt.y - 327, 0, morph);
        st.cup.style.transformBox = 'view-box';
        st.cup.style.transformOrigin = '800px 252px';
        st.cup.style.transform = 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px) scale(' + sc2.toFixed(4) + ')';
      }
      var cupIn = cl((morph - 0.42) / 0.46, 0, 1);
      set(st.seed, 1 - cl((morph - 0.55) / 0.4, 0, 1));
      set(st.cupImg, cupIn);

      var stm = sg(p, 0.948, 0.985);
      set(st.steam, stm * 0.5);
      st.wisps.forEach(function (w, i) {
        var t3 = now * 0.34 + i * 2.1;
        w.style.transformBox = 'view-box';
        w.style.transformOrigin = '800px 210px';
        w.style.transform = 'translate(' + (Math.sin(t3) * 9).toFixed(2) + 'px,' + (-((now * 11 + i * 40) % 120)).toFixed(1) + 'px) scaleY(' + (1 + 0.1 * Math.sin(t3 * 0.8)).toFixed(3) + ')';
        var cyc = ((now * 11 + i * 40) % 120) / 120;
        w.style.opacity = String((0.5 - i * 0.11) * Math.sin(cyc * Math.PI));
      });

      st.beans.forEach(function (el, i) {
        var bx = +el.getAttribute('data-bx'), by = +el.getAttribute('data-by'), br = +el.getAttribute('data-brot');
        var st0 = 0.93 + i * 0.0016;
        var t2 = ez(sg(p, st0, st0 + 0.03));
        var ease2 = 0.24 * (1 - t2);
        var bxp = 800 + bx * (1 - ease2), byp = 252 + by * (1 - ease2);
        var bob = fl(0.5 + i * 0.07, 1.6, i * 1.1) * t2;
        el.style.opacity = String(Math.min(1, t2 * 1.6));
        el.setAttribute('transform', 'translate(' + bxp.toFixed(1) + ',' + (byp + bob).toFixed(1) + ') rotate(' + lp(br - 26, br, t2).toFixed(1) + ') scale(' + lp(0.72, 1, t2).toFixed(3) + ')');
      });

      set(st.finType, sg(p, 0.948, 0.974));
      if (st.ctag) {
        var ct = sg(p, 0.966, 0.994);
        st.ctag.style.opacity = String(ct);
        st.ctag.style.pointerEvents = ct > 0.9 ? 'auto' : 'none';
        st.ctag.style.transformBox = 'view-box';
        st.ctag.style.transformOrigin = '800px 672px';
        st.ctag.style.transform = 'translateY(' + lp(14, 0, ez(ct)).toFixed(1) + 'px)';
      }

      set(st.c1, 1 - sg(p, 0.4, 0.465), 'none');
      set(st.c2, sg(p, 0.455, 0.515) * (1 - sg(p, 0.7, 0.76)),
        'translateY(' + lp(18, 0, ez(sg(p, 0.455, 0.515))).toFixed(1) + 'px)');
      set(st.c3, sg(p, 0.745, 0.805) * (1 - sg(p, 0.878, 0.918)),
        'translateY(' + lp(18, 0, ez(sg(p, 0.755, 0.815))).toFixed(1) + 'px)');

      var dark = ez(sg(p, 0.715, 0.815));
      if (st.sticky) st.sticky.style.background = mix([255, 255, 255], [10, 10, 10], dark);
      var ink = mix([10, 10, 10], [245, 241, 232], dark);
      if (st.svg) st.svg.style.color = ink;
      var eye = mix(st.goldInkRgb, st.goldRgb, dark);
      st.eyebrows.forEach(function (el) { el.style.color = eye; });
      var copy = st.root.querySelector('[data-story-copy]');
      if (copy) copy.style.color = ink;
      if (st.rail) st.rail.style.background = dark > 0.5 ? 'rgba(245,241,232,.14)' : 'rgba(10,10,10,.10)';
    }

    var last = 0;
    function loop(ts) {
      var roots = document.querySelectorAll('[data-subs-story]');
      if (ts - last > 32) {
        last = ts;
        for (var i = 0; i < roots.length; i++) {
          var root = roots[i];
          var r = root.getBoundingClientRect();
          if (r.height > 0 && r.top < window.innerHeight && r.bottom > 0) {
            try { tick(build(root)); } catch (e) {}
          }
        }
      }
      requestAnimationFrame(loop);
    }

    function boot() {
      document.querySelectorAll('[data-subs-story]').forEach(function (root) {
        try { tick(build(root)); } catch (e) {}
      });
    }

    if (!window.__leivasSubsJourney) {
      window.__leivasSubsJourney = true;
      requestAnimationFrame(loop);
      window.addEventListener('resize', function () {
        document.querySelectorAll('[data-subs-story]').forEach(function (root) {
          if (root.__subsStory) {
            applyLayout(root.__subsStory);
            if (root.__subsStory.route) {
              root.__subsStory.routeLen = root.__subsStory.route.getTotalLength();
              root.__subsStory.milePts = null;
            }
          }
        });
      });
      document.addEventListener('shopify:section:load', function (e) {
        var el = e.target.querySelector('[data-subs-story]');
        if (el) { el.__subsStory = null; try { tick(build(el)); } catch (err) {} }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roastery-events-section"] && !Shopify.designMode) return;
  try {
    
  function initLeivasRoasteryEvents() {
    var roots = document.querySelectorAll('[data-reveal-root]');
    if (!roots.length) return;

    if (!('IntersectionObserver' in window)) {
      roots.forEach(function (root) { root.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    roots.forEach(function (root) {
      if (root.dataset.roasteryEventsBound === 'true') return;
      root.dataset.roasteryEventsBound = 'true';
      observer.observe(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLeivasRoasteryEvents);
  } else {
    initLeivasRoasteryEvents();
  }

  document.addEventListener('shopify:section:load', initLeivasRoasteryEvents);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roastery-gallery-section"] && !Shopify.designMode) return;
  try {
    
  function initLeivasRoasteryGallery() {
    var roots = document.querySelectorAll('.leivas-roastery-gallery [data-reveal-root]');
    if (!roots.length) return;

    if (!('IntersectionObserver' in window)) {
      roots.forEach(function (root) { root.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    roots.forEach(function (root) {
      if (root.dataset.roasteryGalleryBound === 'true') return;
      root.dataset.roasteryGalleryBound = 'true';
      observer.observe(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLeivasRoasteryGallery);
  } else {
    initLeivasRoasteryGallery();
  }

  document.addEventListener('shopify:section:load', initLeivasRoasteryGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roastery-intro-section"] && !Shopify.designMode) return;
  try {
    
  function initLeivasRoasteryIntro() {
    document.querySelectorAll('[data-roastery-intro]').forEach(function (section) {
      if (section.dataset.roasteryIntroBound === 'true') return;
      section.dataset.roasteryIntroBound = 'true';

      var items = section.querySelectorAll('[data-reveal-item]');
      if (!items.length) return;

      items.forEach(function (item) {
        var delay = item.dataset.delay;
        if (delay) item.style.transitionDelay = (parseInt(delay, 10) / 1000) + 's';
      });

      if (!('IntersectionObserver' in window)) {
        items.forEach(function (item) { item.classList.add('is-visible'); });
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      items.forEach(function (item) { observer.observe(item); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLeivasRoasteryIntro);
  } else {
    initLeivasRoasteryIntro();
  }

  document.addEventListener('shopify:section:load', initLeivasRoasteryIntro);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roastery-visit-section"] && !Shopify.designMode) return;
  try {
    
  function initLeivasRoasteryVisit() {
    var roots = document.querySelectorAll('[data-reveal-root]');
    if (!roots.length) return;

    if (!('IntersectionObserver' in window)) {
      roots.forEach(function (root) { root.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    roots.forEach(function (root) {
      if (root.dataset.roasteryVisitBound === 'true') return;
      root.dataset.roasteryVisitBound = 'true';
      observer.observe(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLeivasRoasteryVisit);
  } else {
    initLeivasRoasteryVisit();
  }

  document.addEventListener('shopify:section:load', initLeivasRoasteryVisit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-intro-section"] && !Shopify.designMode) return;
  try {
    
  function initLeivasStoryIntro() {
    document.querySelectorAll('[data-story-intro]').forEach(function (section) {
      if (section.dataset.storyIntroBound === 'true') return;
      section.dataset.storyIntroBound = 'true';

      var items = section.querySelectorAll('[data-reveal-item]');
      if (!items.length) return;

      items.forEach(function (item) {
        var delay = item.dataset.delay;
        if (delay) item.style.transitionDelay = (parseInt(delay, 10) / 1000) + 's';
      });

      if (!('IntersectionObserver' in window)) {
        items.forEach(function (item) { item.classList.add('is-visible'); });
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      items.forEach(function (item) { observer.observe(item); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLeivasStoryIntro);
  } else {
    initLeivasStoryIntro();
  }

  document.addEventListener('shopify:section:load', initLeivasStoryIntro);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-photo-section"] && !Shopify.designMode) return;
  try {
    
  function initLeivasStoryPhoto() {
    document.querySelectorAll('[data-story-photo]').forEach(function (root) {
      if (root.dataset.storyPhotoBound === 'true') return;
      root.dataset.storyPhotoBound = 'true';

      if ('IntersectionObserver' in window) {
        var revealObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1 });
        revealObserver.observe(root);
      } else {
        root.classList.add('is-visible');
      }

      var img = root.querySelector('.leivas-story-photo__img');
      if (!img) return;
      if (!window.matchMedia('(pointer: fine)').matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      function pointerFrom(e) {
        var rect = root.getBoundingClientRect();
        return {
          px: (e.clientX - rect.left) / rect.width,
          py: (e.clientY - rect.top) / rect.height,
        };
      }

      function apply(px, py, duration) {
        var cx = px - 0.5;
        var cy = py - 0.5;
        img.style.transitionDuration = duration;
        img.style.transform = 'scale(1.12) rotate(' + (cx * 1.6) + 'deg) translate3d(' + (-cx * 40) + 'px,' + (-cy * 26) + 'px,0)';
      }

      function onEnter(e) {
        var p = pointerFrom(e);
        apply(p.px, p.py, '0.5s');
      }
      function onMove(e) {
        var p = pointerFrom(e);
        apply(p.px, p.py, '0.4s');
      }
      function onLeave() {
        img.style.transitionDuration = '0.9s';
        img.style.transform = 'scale(1) rotate(0deg) translate3d(0,0,0)';
      }

      root.addEventListener('mouseenter', onEnter);
      root.addEventListener('mousemove', onMove, { passive: true });
      root.addEventListener('mouseleave', onLeave);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLeivasStoryPhoto);
  } else {
    initLeivasStoryPhoto();
  }

  document.addEventListener('shopify:section:load', initLeivasStoryPhoto);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-video-section"] && !Shopify.designMode) return;
  try {
    
  var LEIVAS_VIDEO_ICON_STYLE = 'width="18" height="18" fill="#fff"';
  var LEIVAS_VIDEO_ICONS = {
    play: '<svg viewBox="0 0 24 24" ' + LEIVAS_VIDEO_ICON_STYLE + ' aria-hidden="true"><path d="M8 5v14l11-7z"></path></svg>',
    pause: '<svg viewBox="0 0 24 24" ' + LEIVAS_VIDEO_ICON_STYLE + ' aria-hidden="true"><rect x="6" y="5" width="4" height="14"></rect><rect x="14" y="5" width="4" height="14"></rect></svg>',
    volume: '<svg viewBox="0 0 24 24" ' + LEIVAS_VIDEO_ICON_STYLE + ' aria-hidden="true"><path d="M3 10v4h4l5 5V5L7 10H3z"></path><path d="M14.5 12c0-1.77-1.02-3.29-2.5-4.03v8.06c1.48-.74 2.5-2.26 2.5-4.03z"></path><path d="M14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"></path></svg>',
    muted: '<svg viewBox="0 0 24 24" ' + LEIVAS_VIDEO_ICON_STYLE + ' aria-hidden="true"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.8L19.73 21 21 19.73 4.27 3z"></path></svg>'
  };

  function initLeivasVideos() {
    document.querySelectorAll('[data-video-section]').forEach(function (section) {
      if (section.dataset.videoBound === 'true') return;

      var frame = section.querySelector('[data-video-frame]');
      var cursor = section.querySelector('[data-video-cursor]');
      var poster = section.querySelector('[data-video-poster]');
      if (!frame) return;

      section.dataset.videoBound = 'true';

      if (poster && poster.dataset.fallback) {
        poster.addEventListener('error', function () {
          if (poster.src !== poster.dataset.fallback) poster.src = poster.dataset.fallback;
        });
      }

      function play() {
        if (frame.classList.contains('is-playing')) return;
        var type = frame.dataset.videoType;
        var id = frame.dataset.videoId;
        if (!type || !id) return;

        var facade = frame.querySelector('[data-video-facade]');
        if (facade) facade.style.display = 'none';

        var src = type === 'vimeo'
          ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&controls=0'
          : 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&controls=0&rel=0&modestbranding=1&playsinline=1&iv_load_policy=3&disablekb=1&fs=0&enablejsapi=1';

        var iframe = document.createElement('iframe');
        iframe.className = 'leivas-video__iframe';
        iframe.src = src;
        iframe.title = frame.dataset.videoTitle || 'Video';
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('frameborder', '0');
        frame.appendChild(iframe);

        var state = { paused: false, muted: false };

        function sendCommand(action) {
          if (!iframe.contentWindow) return;
          var payload;
          if (type === 'vimeo') {
            payload = action === 'play' ? { method: 'play' }
              : action === 'pause' ? { method: 'pause' }
              : action === 'mute' ? { method: 'setMuted', value: true }
              : { method: 'setMuted', value: false };
          } else {
            payload = {
              event: 'command',
              func: action === 'play' ? 'playVideo' : action === 'pause' ? 'pauseVideo' : action === 'mute' ? 'mute' : 'unMute',
              args: []
            };
          }
          iframe.contentWindow.postMessage(JSON.stringify(payload), '*');
        }

        // Inline styles below are a deliberate belt-and-suspenders fallback:
        // these three elements/classes are newly introduced alongside this
        // script, and Shopify compiles a section's style block and script
        // block into two separately-cached asset files — if only one of the
        // two has propagated to a given visitor, relying on the external
        // stylesheet alone could leave these unstyled. Setting the critical
        // layout/appearance directly here guarantees correct rendering
        // regardless of that CSS asset's cache state.
        var pauseCover = document.createElement('button');
        pauseCover.type = 'button';
        pauseCover.className = 'leivas-video__pause-cover';
        pauseCover.setAttribute('aria-label', 'Resume video');
        // display (not the `hidden` attribute) is what actually controls
        // this element's visibility — a direct inline style always wins
        // over the browser's own [hidden] rule, so mixing the two would
        // make `hidden` a no-op once an inline `display` is also set.
        pauseCover.style.cssText = 'position:absolute;inset:0;z-index:4;display:none;width:100%;border:0;padding:0;background:rgba(10,10,10,.86);cursor:pointer;';
        pauseCover.innerHTML =
          '<span class="leivas-video__trigger">' +
          '<svg class="leivas-video__trigger-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"></path></svg>' +
          '</span>';

        var controls = document.createElement('div');
        controls.className = 'leivas-video__controls';
        controls.style.cssText = 'position:absolute;right:20px;bottom:20px;z-index:5;display:flex;gap:10px;';

        var CONTROL_BTN_STYLE = 'width:40px;height:40px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:rgba(10,10,10,.55);border:1px solid rgba(255,255,255,.25);cursor:pointer;';

        var pauseBtn = document.createElement('button');
        pauseBtn.type = 'button';
        pauseBtn.className = 'leivas-video__control-btn';
        pauseBtn.setAttribute('aria-label', 'Pause');
        pauseBtn.style.cssText = CONTROL_BTN_STYLE;
        pauseBtn.innerHTML = LEIVAS_VIDEO_ICONS.pause;

        var muteBtn = document.createElement('button');
        muteBtn.type = 'button';
        muteBtn.className = 'leivas-video__control-btn';
        muteBtn.setAttribute('aria-label', 'Mute');
        muteBtn.style.cssText = CONTROL_BTN_STYLE;
        muteBtn.innerHTML = LEIVAS_VIDEO_ICONS.volume;

        function togglePause(e) {
          e.stopPropagation();
          state.paused = !state.paused;
          sendCommand(state.paused ? 'pause' : 'play');
          pauseCover.style.display = state.paused ? 'block' : 'none';
          pauseBtn.innerHTML = state.paused ? LEIVAS_VIDEO_ICONS.play : LEIVAS_VIDEO_ICONS.pause;
          pauseBtn.setAttribute('aria-label', state.paused ? 'Play' : 'Pause');
        }
        function toggleMute(e) {
          e.stopPropagation();
          state.muted = !state.muted;
          sendCommand(state.muted ? 'mute' : 'unmute');
          muteBtn.innerHTML = state.muted ? LEIVAS_VIDEO_ICONS.muted : LEIVAS_VIDEO_ICONS.volume;
          muteBtn.setAttribute('aria-label', state.muted ? 'Unmute' : 'Mute');
        }

        pauseCover.addEventListener('click', togglePause);
        pauseBtn.addEventListener('click', togglePause);
        muteBtn.addEventListener('click', toggleMute);

        controls.appendChild(pauseBtn);
        controls.appendChild(muteBtn);
        frame.appendChild(pauseCover);
        frame.appendChild(controls);

        frame.classList.add('is-playing');
      }

      frame.addEventListener('click', play);

      if (!cursor) return;
      if (!window.matchMedia('(pointer: fine)').matches) return;

      var x = 0;
      var y = 0;
      var tx = 0;
      var ty = 0;
      var raf = null;

      function step() {
        x += (tx - x) * 0.22;
        y += (ty - y) * 0.22;
        cursor.style.transform = 'translate(' + x + 'px,' + y + 'px) translate(-50%,-50%)';
        raf = window.requestAnimationFrame(step);
      }

      function onMove(e) {
        if (frame.classList.contains('is-playing')) return;
        var rect = frame.getBoundingClientRect();
        tx = e.clientX - rect.left;
        ty = e.clientY - rect.top;
        if (!raf) raf = window.requestAnimationFrame(step);
      }

      function onEnter(e) {
        if (frame.classList.contains('is-playing')) return;
        var rect = frame.getBoundingClientRect();
        x = tx = e.clientX - rect.left;
        y = ty = e.clientY - rect.top;
        cursor.classList.add('is-active');
        cursor.style.transform = 'translate(' + x + 'px,' + y + 'px) translate(-50%,-50%)';
        if (!raf) raf = window.requestAnimationFrame(step);
      }

      function onLeave() {
        cursor.classList.remove('is-active');
        if (raf) window.cancelAnimationFrame(raf);
        raf = null;
      }

      frame.addEventListener('mouseenter', onEnter);
      frame.addEventListener('mousemove', onMove, { passive: true });
      frame.addEventListener('mouseleave', onLeave);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLeivasVideos);
  } else {
    initLeivasVideos();
  }

  document.addEventListener('shopify:section:load', initLeivasVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-builder-section"] && !Shopify.designMode) return;
  try {
    
  function initLeivasSubBuilder(root) {
    if (root.dataset.subBuilderBound === 'true') return;
    root.dataset.subBuilderBound = 'true';

    var products = {};
    root.querySelectorAll('[data-sub-builder-product]').forEach(function (el) {
      try {
        var p = JSON.parse(el.textContent);
        products[String(p.id)] = p;
      } catch (err) {}
    });

    var configEl = root.querySelector('[data-sub-builder-config]');
    var config = { cartAddUrl: '/cart/add.js' };
    if (configEl) {
      try { config = JSON.parse(configEl.textContent); } catch (err) {}
    }

    var panel = root.querySelector('[data-sub-builder-panel]');
    if (!panel) return;

    function escapeHtml(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function stripHtml(html) {
      var div = document.createElement('div');
      div.innerHTML = html || '';
      return div.textContent || '';
    }

    function findVariant(product, selections) {
      return product.variants.find(function (v) {
        return product.options.every(function (opt, i) {
          return v['option' + (i + 1)] === selections[i];
        });
      });
    }

    function planNameFor(product, planId) {
      var found = null;
      (product.selling_plan_groups || []).forEach(function (group) {
        (group.selling_plans || []).forEach(function (plan) {
          if (plan.id === planId) found = group.name || plan.name;
        });
      });
      return found || 'Subscription';
    }

    function percentOff(allocation, comparePrice) {
      var adj = allocation && allocation.price_adjustments && allocation.price_adjustments[0];
      if (adj && adj.value_type === 'percentage') return Math.round(adj.value) + '%';
      // Fall back to computing it directly from the prices themselves, in case
      // this store's price_adjustments don't carry a plain percentage value.
      if (allocation && comparePrice && allocation.price < comparePrice) {
        return Math.round((1 - allocation.price / comparePrice) * 100) + '%';
      }
      return null;
    }

    var state = {};

    function renderPanel(productId) {
      var product = products[String(productId)];
      if (!product) return;

      try {
        renderPanelUnsafe(product, productId);
      } catch (err) {
        panel.innerHTML = '<p class="leivas-sub-builder__error">This coffee could not be loaded (' + escapeHtml(err.message) + '). Please refresh, or visit its product page to subscribe there.</p>';
        if (window.console) window.console.error('leivas-sub-builder', err);
      }
    }

    function renderPanelUnsafe(product, productId) {
      var defaultVariant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      var selections = product.options.map(function (opt, i) {
        return defaultVariant['option' + (i + 1)];
      });

      var images = (product.images && product.images.length) ? product.images : [product.featured_image].filter(Boolean);

      state = {
        productId: productId,
        selections: selections,
        variant: defaultVariant,
        planId: (defaultVariant.selling_plan_allocations && defaultVariant.selling_plan_allocations[0]) ? defaultVariant.selling_plan_allocations[0].selling_plan_id : null,
        qty: 1,
        activeImage: 0,
      };

      var thumbsHtml = images.map(function (src, i) {
        return '<button type="button" class="leivas-sub-builder__thumb' + (i === 0 ? ' is-selected' : '') + '" data-thumb-index="' + i + '"><img src="' + src + '&width=100" alt=""></button>';
      }).join('');

      var optionsHtml = product.options.map(function (opt, i) {
        var optionsListHtml = opt.values.map(function (v) {
          return '<option value="' + escapeHtml(v) + '"' + (v === selections[i] ? ' selected' : '') + '>' + escapeHtml(v) + '</option>';
        }).join('');
        return '<div class="leivas-sub-builder__field"><label>' + escapeHtml(opt.name) + '</label><select data-option-index="' + i + '">' + optionsListHtml + '</select></div>';
      }).join('');

      var hasPlans = !!(defaultVariant.selling_plan_allocations && defaultVariant.selling_plan_allocations.length);

      var notes = product.description ? escapeHtml(stripHtml(product.description)).slice(0, 110) : '';

      panel.innerHTML =
        '<div class="leivas-sub-builder__gallery">' +
          '<div class="leivas-sub-builder__thumbs">' + thumbsHtml + '</div>' +
          '<div class="leivas-sub-builder__media"><img data-main-image src="' + (images[0] || '') + '&width=700" alt="' + escapeHtml(product.title) + '"></div>' +
        '</div>' +
        '<div class="leivas-sub-builder__config">' +
          '<h3 class="leivas-sub-builder__name">' + escapeHtml(product.title) + '</h3>' +
          (notes ? '<p class="leivas-sub-builder__notes">' + notes + '</p>' : '') +
          '<div class="leivas-sub-builder__fields-row">' + optionsHtml + '</div>' +
          '<div class="leivas-sub-builder__plans" data-plans-slot></div>' +
          (hasPlans ? '' : '<p class="leivas-sub-builder__one-time-note">This coffee is available as a one-time purchase.</p>') +
          '<div class="leivas-sub-builder__buy-row">' +
            '<div class="leivas-sub-builder__stepper">' +
              '<button type="button" data-qty-decrease aria-label="Decrease quantity">−</button>' +
              '<span data-qty-display>1</span>' +
              '<button type="button" data-qty-increase aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="leivas-sub-builder__add" data-add-to-cart>Add to Cart</button>' +
          '</div>' +
          '<div class="leivas-sub-builder__confirm" data-cart-confirm hidden></div>' +
        '</div>';

      renderPlans();
      updateAddButton();
      bindPanelEvents();
    }

    function renderPlans() {
      var product = products[String(state.productId)];
      var slot = panel.querySelector('[data-plans-slot]');
      if (!product || !slot) return;

      var variant = state.variant;
      var allocations = (variant && variant.selling_plan_allocations) || [];
      if (!allocations.length) { slot.innerHTML = ''; return; }

      var activeAllocation = allocations.find(function (a) { return a.selling_plan_id === state.planId; }) || allocations[0];
      state.planId = activeAllocation.selling_plan_id;
      var savePct = percentOff(activeAllocation, variant.price);

      var cadenceHtml = allocations.map(function (a) {
        var isSelected = a.selling_plan_id === state.planId;
        var label = planNameFor(product, a.selling_plan_id).replace(/^Delivery\s+/i, '');
        var pct = percentOff(a, variant.price);
        return '<button type="button" class="leivas-sub-builder__cadence' + (isSelected ? ' is-selected' : '') + '" data-plan-id="' + a.selling_plan_id + '">' +
          '<span>' + escapeHtml(label) + '</span>' +
          (pct ? '<em>save ' + pct + '</em>' : '') +
          '</button>';
      }).join('');

      slot.innerHTML =
        '<div class="leivas-sub-builder__plan">' +
          '<div class="leivas-sub-builder__plan-hit">' +
            '<span class="leivas-sub-builder__plan-label-group">' +
              '<span class="leivas-sub-builder__plan-label">Subscribe &amp; Save</span>' +
              (savePct ? '<span class="leivas-sub-builder__save-tag">Save ' + savePct + '</span>' : '') +
            '</span>' +
            '<span class="leivas-sub-builder__plan-price" data-plan-price>' +
              '<span class="leivas-sub-builder__was">' + money(variant.price) + '</span> ' + money(activeAllocation.price) +
            '</span>' +
          '</div>' +
          '<div class="leivas-sub-builder__plan-body">' +
            '<ul class="leivas-sub-builder__perks">' +
              '<li>Save automatically on every order</li>' +
              '<li>Never run out</li>' +
              '<li>No commitment — cancel anytime</li>' +
            '</ul>' +
            '<div class="leivas-sub-builder__cadence-label">Deliver every:</div>' +
            '<div class="leivas-sub-builder__cadence-grid">' + cadenceHtml + '</div>' +
          '</div>' +
        '</div>';

      slot.querySelectorAll('[data-plan-id]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.planId = Number(btn.getAttribute('data-plan-id'));
          renderPlans();
        });
      });
    }

    function updateAddButton() {
      var btn = panel.querySelector('[data-add-to-cart]');
      if (!btn) return;
      var available = state.variant && state.variant.available;
      btn.disabled = !available;
      var priceCents = state.planId && state.variant.selling_plan_allocations
        ? (state.variant.selling_plan_allocations.find(function (a) { return a.selling_plan_id === state.planId; }) || {}).price
        : state.variant.price;
      var total = (priceCents || 0) * state.qty;
      btn.textContent = available ? ('Add to Cart · ' + money(total)) : 'Out of Stock';
    }

    function bindPanelEvents() {
      var product = products[String(state.productId)];

      panel.querySelectorAll('[data-option-index]').forEach(function (select) {
        select.addEventListener('change', function () {
          var index = Number(select.getAttribute('data-option-index'));
          state.selections[index] = select.value;
          var matched = findVariant(product, state.selections);
          if (matched) {
            state.variant = matched;
            var allocations = matched.selling_plan_allocations || [];
            state.planId = allocations.length ? allocations[0].selling_plan_id : null;
            renderPlans();
            updateAddButton();
          }
        });
      });

      panel.querySelectorAll('[data-thumb-index]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var index = Number(thumb.getAttribute('data-thumb-index'));
          var images = (product.images && product.images.length) ? product.images : [product.featured_image].filter(Boolean);
          var mainImg = panel.querySelector('[data-main-image]');
          if (mainImg && images[index]) mainImg.src = images[index] + '&width=700';
          panel.querySelectorAll('[data-thumb-index]').forEach(function (t) { t.classList.remove('is-selected'); });
          thumb.classList.add('is-selected');
        });
      });

      var qtyDisplay = panel.querySelector('[data-qty-display]');
      panel.querySelector('[data-qty-decrease]').addEventListener('click', function () {
        state.qty = Math.max(1, state.qty - 1);
        qtyDisplay.textContent = state.qty;
        updateAddButton();
      });
      panel.querySelector('[data-qty-increase]').addEventListener('click', function () {
        state.qty = state.qty + 1;
        qtyDisplay.textContent = state.qty;
        updateAddButton();
      });

      panel.querySelector('[data-add-to-cart]').addEventListener('click', function () {
        addToCart(this);
      });
    }

    // This store's theme (its <ce-cart> custom element) listens specifically
    // for a "Themu:cart:add" event carrying pre-rendered section HTML, and
    // opens its drawer via a click on [data-cart-drawer-button-open] — both
    // confirmed directly against the live theme's own JS, not guessed.
    function notifyThemeCartChanged(sections) {
      if (sections) {
        document.dispatchEvent(new CustomEvent('Themu:cart:add', { detail: sections, bubbles: true }));
      }
      var openBtn = document.querySelector('[data-cart-drawer-button-open]');
      if (openBtn) openBtn.click();
    }

    function showCartConfirm(product, qty) {
      var box = panel.querySelector('[data-cart-confirm]');
      if (!box) return;
      box.hidden = false;
      box.innerHTML =
        '<p>' + escapeHtml(product.title) + ' × ' + qty + ' added to your cart.</p>' +
        '<a href="/cart">View Cart</a>';
    }

    function addToCart(btn) {
      if (btn.disabled) return;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      var product = products[String(state.productId)];
      var item = { id: state.variant.id, quantity: state.qty };
      if (state.planId) item.selling_plan = state.planId;

      fetch(config.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item], sections: ['cart-data', 'cart-drawer', 'cart-drawer-notification'] }),
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || 'Add to cart failed'); });
          return res.json();
        })
        .then(function (data) {
          btn.textContent = 'Added ✓';
          notifyThemeCartChanged(data.sections);
          showCartConfirm(product, state.qty);
          setTimeout(function () {
            btn.disabled = false;
            updateAddButton();
          }, 2200);
        })
        .catch(function (err) {
          btn.textContent = 'Something went wrong';
          if (window.console) window.console.error('leivas-sub-builder add to cart', err);
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = originalText;
          }, 2200);
        });
    }

    root.querySelectorAll('[data-roast-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var groupId = tab.getAttribute('data-roast-group');
        root.querySelectorAll('[data-roast-tab]').forEach(function (t) { t.classList.remove('is-selected'); });
        tab.classList.add('is-selected');
        root.querySelectorAll('[data-roast-panel]').forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-roast-panel') === groupId);
        });
        var firstPick = root.querySelector('[data-roast-panel="' + groupId + '"] [data-product-id]');
        if (firstPick) {
          root.querySelectorAll('[data-product-id]').forEach(function (p) { p.classList.remove('is-selected'); });
          firstPick.classList.add('is-selected');
          renderPanel(firstPick.getAttribute('data-product-id'));
        }
      });
    });

    root.querySelectorAll('[data-product-id]').forEach(function (pick) {
      pick.addEventListener('click', function () {
        root.querySelectorAll('[data-product-id]').forEach(function (p) { p.classList.remove('is-selected'); });
        pick.classList.add('is-selected');
        renderPanel(pick.getAttribute('data-product-id'));
      });
    });

    var firstPick = root.querySelector('[data-product-id]');
    if (firstPick) renderPanel(firstPick.getAttribute('data-product-id'));
  }

  function initLeivasSubBuilderReveal(root) {
    var roots = root.querySelectorAll('[data-reveal-root]');
    if (!roots.length) return;

    if (!('IntersectionObserver' in window)) {
      roots.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    roots.forEach(function (el) { observer.observe(el); });
  }

  function bootLeivasSubBuilder() {
    document.querySelectorAll('.leivas-sub-builder').forEach(function (root) {
      initLeivasSubBuilder(root);
      initLeivasSubBuilderReveal(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootLeivasSubBuilder);
  } else {
    bootLeivasSubBuilder();
  }

  document.addEventListener('shopify:section:load', bootLeivasSubBuilder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-cadence-section"] && !Shopify.designMode) return;
  try {
    
  function initLeivasSubCadenceReveal(root) {
    var roots = root.querySelectorAll('[data-reveal-root]');
    if (!roots.length) return;

    if (!('IntersectionObserver' in window)) {
      roots.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    roots.forEach(function (el) { observer.observe(el); });
  }

  function bootLeivasSubCadence() {
    document.querySelectorAll('.leivas-sub-cadence').forEach(initLeivasSubCadenceReveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootLeivasSubCadence);
  } else {
    bootLeivasSubCadence();
  }

  document.addEventListener('shopify:section:load', bootLeivasSubCadence);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-hero-section"] && !Shopify.designMode) return;
  try {
    
  function initLeivasSubHero() {
    var roots = document.querySelectorAll('.leivas-sub-hero [data-reveal-root]');
    if (!roots.length) return;

    if (!('IntersectionObserver' in window)) {
      roots.forEach(function (root) { root.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    roots.forEach(function (root) {
      if (root.dataset.subHeroBound === 'true') return;
      root.dataset.subHeroBound = 'true';
      observer.observe(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLeivasSubHero);
  } else {
    initLeivasSubHero();
  }

  document.addEventListener('shopify:section:load', initLeivasSubHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-savings-section"] && !Shopify.designMode) return;
  try {
    
  function initLeivasSubSavingsReveal(root) {
    var roots = root.querySelectorAll('[data-reveal-root]');
    if (!roots.length) return;

    if (!('IntersectionObserver' in window)) {
      roots.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    roots.forEach(function (el) { observer.observe(el); });
  }

  function bootLeivasSubSavings() {
    document.querySelectorAll('.leivas-sub-savings').forEach(initLeivasSubSavingsReveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootLeivasSubSavings);
  } else {
    bootLeivasSubSavings();
  }

  document.addEventListener('shopify:section:load', bootLeivasSubSavings);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-trust-badges-section"] && !Shopify.designMode) return;
  try {
    
  function initLeivasTrustBadgesReveal(root) {
    var roots = root.querySelectorAll('[data-reveal-root]');
    if (!roots.length) return;

    if (!('IntersectionObserver' in window)) {
      roots.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    roots.forEach(function (el) { observer.observe(el); });
  }

  function bootLeivasTrustBadges() {
    document.querySelectorAll('.leivas-trust-badges').forEach(initLeivasTrustBadgesReveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootLeivasTrustBadges);
  } else {
    bootLeivasTrustBadges();
  }

  document.addEventListener('shopify:section:load', bootLeivasTrustBadges);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-section"] && !Shopify.designMode) return;
  try {
    
  function initLeivasTimelines() {
    document.querySelectorAll('[data-timeline-section]').forEach(function (section) {
      if (section.dataset.timelineBound === 'true') return;

      var pin = section.querySelector('[data-timeline-pin]');
      var track = section.querySelector('[data-timeline-track]');
      var bgWrap = section.querySelector('[data-timeline-bg-wrap]');
      var bg = section.querySelector('[data-timeline-bg]');
      if (!pin || !track) return;

      section.dataset.timelineBound = 'true';

      var bgAspect = 3;
      if (bg && bg.dataset.ratio) {
        var parsed = parseFloat(bg.dataset.ratio);
        if (parsed > 0) bgAspect = parsed;
      }

      var parallaxFactor = 0.45;
      // How quickly the rendered position chases the scroll-derived target
      // each frame — lower is laggier/more "floaty", higher snaps closer to
      // 1:1 with the raw scroll. This is what gives the cards inertia and a
      // natural deceleration instead of stopping the instant scrolling does.
      var smoothing = 0.09;

      function skip() {
        return window.matchMedia('(max-width: 989px), (prefers-reduced-motion: reduce)').matches;
      }

      var target = 0;
      var current = 0;
      var renderRaf = null;

      function render() {
        current += (target - current) * smoothing;
        if (Math.abs(target - current) < 0.0003) current = target;

        var trackRange = Math.max(0, track.scrollWidth - window.innerWidth);
        track.style.transform = 'translate3d(' + (-current * trackRange) + 'px,0,0)';

        if (bg && bgWrap) {
          var pinHeight = pin.offsetHeight;
          var bgWidth = pinHeight * bgAspect;
          bg.style.width = bgWidth + 'px';
          var bgMaxPan = Math.max(0, bgWidth - window.innerWidth);
          var bgRange = Math.min(bgMaxPan, trackRange * parallaxFactor);
          bg.style.transform = 'translate3d(' + (-current * bgRange) + 'px,0,0)';
        }

        renderRaf = current !== target ? window.requestAnimationFrame(render) : null;
      }

      var ticking = false;
      function updateTarget() {
        if (skip()) return;
        var rect = section.getBoundingClientRect();
        var pinHeight = pin.offsetHeight;
        var scrollable = Math.max(1, section.offsetHeight - pinHeight);
        target = Math.min(1, Math.max(0, -rect.top / scrollable));
        if (!renderRaf) renderRaf = window.requestAnimationFrame(render);
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          updateTarget();
          ticking = false;
        });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      updateTarget();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLeivasTimelines);
  } else {
    initLeivasTimelines();
  }

  document.addEventListener('shopify:section:load', initLeivasTimelines);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-application-form-section"] && !Shopify.designMode) return;
  try {
    
  function initLeivasWholesaleApply() {
    var roots = document.querySelectorAll('.leivas-wholesale-apply [data-reveal-root]');
    if (!roots.length) return;

    if (!('IntersectionObserver' in window)) {
      roots.forEach(function (root) { root.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    roots.forEach(function (root) {
      if (root.dataset.wholesaleApplyBound === 'true') return;
      root.dataset.wholesaleApplyBound = 'true';
      observer.observe(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLeivasWholesaleApply);
  } else {
    initLeivasWholesaleApply();
  }

  document.addEventListener('shopify:section:load', initLeivasWholesaleApply);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-hero-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReveal() {
      var roots = document.querySelectorAll('[data-reveal-root]');
      if (!roots.length) return;

      if (!('IntersectionObserver' in window)) {
        roots.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      roots.forEach(function (el) {
        if (el.dataset.wholesaleHeroRevealBound === 'true') return;
        el.dataset.wholesaleHeroRevealBound = 'true';
        observer.observe(el);
      });
    }

    function initBeans() {
      var sec = document.querySelector('[data-beans-section]');
      if (!sec || sec.dataset.beansBound === 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var beanUrls;
      try {
        beanUrls = JSON.parse(sec.getAttribute('data-bean-urls'));
      } catch (e) {
        beanUrls = [];
      }
      var countDesktop = parseInt(sec.getAttribute('data-bean-count-desktop'), 10) || 130;
      var countMobile = parseInt(sec.getAttribute('data-bean-count-mobile'), 10) || 60;
      var sizeDesktop = parseInt(sec.getAttribute('data-bean-size-desktop'), 10) || 54;
      var sizeMobile = parseInt(sec.getAttribute('data-bean-size-mobile'), 10) || 36;

      var beanImgs = beanUrls.map(function (src) {
        var im = new Image();
        im.src = src;
        return im;
      });

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.disconnect();
          sec.dataset.beansBound = 'true';
          start();
        });
      }, { rootMargin: '260px 0px' });
      io.observe(sec);

      function start() {
        if (!window.Matter) {
          window.setTimeout(start, 60);
          return;
        }
        var M = window.Matter;
        var cv = sec.querySelector('[data-beans-canvas]');
        var layer = sec.querySelector('[data-beans-layer]');
        if (!cv || !layer) return;
        var ctx = cv.getContext('2d');
        var mobile = window.innerWidth < 760;
        var COUNT = mobile ? countMobile : countDesktop;
        var SZ = mobile ? sizeMobile : sizeDesktop;

        var eng = M.Engine.create();
        eng.gravity.y = 1.3;
        var world = eng.world;
        var W = layer.clientWidth;
        var H = layer.clientHeight;
        var dpr = Math.min(2, window.devicePixelRatio || 1);

        function fit() {
          W = layer.clientWidth;
          H = layer.clientHeight;
          cv.width = Math.round(W * dpr);
          cv.height = Math.round(H * dpr);
          ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        }
        fit();

        var opt = { isStatic: true, restitution: 0.4 };
        var walls = [];
        function rebuild() {
          walls.forEach(function (b) { M.Composite.remove(world, b); });
          walls = [
            M.Bodies.rectangle(W / 2, H + 40, W + 400, 80, opt),
            M.Bodies.rectangle(-40, H / 2, 80, H * 3, opt),
            M.Bodies.rectangle(W + 40, H / 2, 80, H * 3, opt)
          ];
          M.Composite.add(world, walls);
        }
        rebuild();

        var beans = [];
        var dropped = 0;
        var dropTimer;
        function drop() {
          if (dropped >= COUNT) return;
          var w = SZ * (0.84 + Math.random() * 0.4);
          var h = w * 0.96;
          var b = M.Bodies.rectangle(40 + Math.random() * (W - 80), -60 - Math.random() * 300, w * 0.84, h * 0.7, {
            chamfer: { radius: h * 0.28 },
            restitution: 0.55,
            friction: 0.42,
            frictionAir: 0.006,
            density: 0.0013,
            angle: Math.random() * Math.PI
          });
          b.plugin = { w: w, h: h, img: beanImgs[(Math.random() * beanImgs.length) | 0] };
          M.Composite.add(world, b);
          beans.push(b);
          dropped++;
          dropTimer = window.setTimeout(drop, 70);
        }
        drop();

        var mouse = M.Mouse.create(document.createElement('div'));
        mouse.pixelRatio = 1;
        var mc = M.MouseConstraint.create(eng, { mouse: mouse, constraint: { stiffness: 0.16, render: { visible: false } } });
        M.Composite.add(world, mc);

        function at(e) {
          var r = cv.getBoundingClientRect();
          mouse.position.x = mouse.absolute.x = e.clientX - r.left;
          mouse.position.y = mouse.absolute.y = e.clientY - r.top;
        }
        cv.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
          at(e);
          mouse.button = 0;
          cv.style.cursor = 'grabbing';
        }, { passive: true });
        window.addEventListener('pointermove', function (e) {
          if (mouse.button === 0 || e.pointerType === 'mouse') at(e);
        }, { passive: true });
        window.addEventListener('pointerup', function () {
          mouse.button = -1;
          cv.style.cursor = 'grab';
        }, { passive: true });

        function paint() {
          ctx.clearRect(0, 0, W, H);
          for (var i = 0; i < beans.length; i++) {
            var b = beans[i];
            var pl = b.plugin;
            ctx.save();
            ctx.translate(b.position.x, b.position.y);
            ctx.rotate(b.angle);
            if (pl.img && pl.img.complete && pl.img.naturalWidth) {
              ctx.drawImage(pl.img, -pl.w / 2, -pl.h / 2, pl.w, pl.h);
            } else {
              ctx.fillStyle = '#241C17';
              ctx.beginPath();
              ctx.ellipse(0, 0, pl.w * 0.42, pl.h * 0.33, 0, 0, Math.PI * 2);
              ctx.fill();
            }
            ctx.restore();
          }
        }
        var runner = M.Runner.create();
        M.Runner.run(runner, eng);
        M.Events.on(eng, 'afterUpdate', paint);

        var rt;
        window.addEventListener('resize', function () {
          window.clearTimeout(rt);
          rt = window.setTimeout(function () {
            fit();
            rebuild();
          }, 180);
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initReveal(); initBeans(); });
    } else {
      initReveal();
      initBeans();
    }
    document.addEventListener('shopify:section:load', function () { initReveal(); initBeans(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-how-it-works-section"] && !Shopify.designMode) return;
  try {
    
  function initLeivasWholesaleHow() {
    var roots = document.querySelectorAll('.leivas-wholesale-how [data-reveal-root]');
    if (!roots.length) return;

    if (!('IntersectionObserver' in window)) {
      roots.forEach(function (root) { root.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    roots.forEach(function (root) {
      if (root.dataset.wholesaleHowBound === 'true') return;
      root.dataset.wholesaleHowBound = 'true';
      observer.observe(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLeivasWholesaleHow);
  } else {
    initLeivasWholesaleHow();
  }

  document.addEventListener('shopify:section:load', initLeivasWholesaleHow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-product-selector-section"] && !Shopify.designMode) return;
  try {
    
  function initLeivasWholesaleSelect() {
    var sections = document.querySelectorAll('[data-select-section]');

    sections.forEach(function (sec) {
      if (sec.dataset.selectBound === 'true') return;
      sec.dataset.selectBound = 'true';

      var caseSize = parseInt(sec.getAttribute('data-case-size'), 10) || 6;
      var growingMin = parseInt(sec.getAttribute('data-tier-growing-min'), 10) || 5;
      var establishedMin = parseInt(sec.getAttribute('data-tier-established-min'), 10) || 20;
      var cards = sec.querySelectorAll('[data-select-card]');
      var summaryEl = sec.querySelector('[data-select-summary]');
      var emptySummary = summaryEl ? summaryEl.textContent.trim() : '';
      var ctaEl = sec.querySelector('[data-select-cta]');

      var quantities = [];

      cards.forEach(function (card, index) {
        quantities[index] = 0;

        var noteEl = card.querySelector('[data-select-case-note]');
        function renderNote() {
          if (!noteEl) return;
          var cases = quantities[index];
          var html = '1 case = ' + caseSize + ' bags';
          if (cases > 0) {
            html += ' &middot; <strong>' + (cases * caseSize) + ' bags</strong> selected';
          }
          noteEl.innerHTML = html;
        }
        renderNote();

        function render() {
          var cases = quantities[index];
          var qtyEl = card.querySelector('[data-select-qty]');
          var qtyLabelEl = card.querySelector('[data-select-qty-label]');
          var decBtn = card.querySelector('[data-select-decrement]');
          var checkEl = card.querySelector('[data-select-check]');

          if (qtyEl) qtyEl.textContent = cases;
          if (qtyLabelEl) qtyLabelEl.textContent = cases === 1 ? 'case' : 'cases';
          if (decBtn) decBtn.disabled = cases === 0;
          card.classList.toggle('is-selected', cases > 0);
          if (checkEl) {
            if (cases > 0) {
              checkEl.removeAttribute('hidden');
            } else {
              checkEl.setAttribute('hidden', '');
            }
          }
          renderNote();
        }

        var decBtn = card.querySelector('[data-select-decrement]');
        var incBtn = card.querySelector('[data-select-increment]');
        if (decBtn) {
          decBtn.addEventListener('click', function () {
            quantities[index] = Math.max(0, quantities[index] - 1);
            render();
            renderSummary();
          });
        }
        if (incBtn) {
          incBtn.addEventListener('click', function () {
            quantities[index] = quantities[index] + 1;
            render();
            renderSummary();
          });
        }
      });

      function tierFor(totalCases) {
        if (totalCases <= 0) return null;
        if (totalCases < growingMin) return 'Starter';
        if (totalCases < establishedMin) return 'Growing';
        return 'Established';
      }

      function renderSummary() {
        if (!summaryEl) return;
        var totalCases = quantities.reduce(function (sum, n) { return sum + n; }, 0);
        var selectedCount = quantities.filter(function (n) { return n > 0; }).length;
        var tier = tierFor(totalCases);

        if (totalCases > 0) {
          var html = '<strong>' + totalCases + ' ' + (totalCases === 1 ? 'case' : 'cases') + '</strong>';
          html += ' (' + (totalCases * caseSize) + ' bags) across ' + selectedCount + ' ' + (selectedCount === 1 ? 'roast' : 'roasts');
          if (tier) html += ' &mdash; qualifies for <strong>' + tier + '</strong> pricing';
          summaryEl.innerHTML = html;
        } else {
          summaryEl.textContent = emptySummary;
        }
      }

      if (ctaEl) {
        ctaEl.addEventListener('click', function () {
          var body = document.querySelector('textarea[name="contact[body]"]');
          if (!body || body.value.trim() !== '') return;

          var lines = [];
          cards.forEach(function (card, index) {
            if (quantities[index] > 0) {
              lines.push(card.getAttribute('data-product-title') + ' (' + quantities[index] + (quantities[index] === 1 ? ' case' : ' cases') + ')');
            }
          });
          if (lines.length > 0) {
            body.value = 'Interested in: ' + lines.join(', ') + '.';
          }
        });
      }
    });
  }

  function initLeivasWholesaleSelectReveal() {
    var roots = document.querySelectorAll('.leivas-wholesale-select [data-reveal-root]');
    if (!roots.length) return;

    if (!('IntersectionObserver' in window)) {
      roots.forEach(function (root) { root.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    roots.forEach(function (root) {
      if (root.dataset.wholesaleSelectRevealBound === 'true') return;
      root.dataset.wholesaleSelectRevealBound = 'true';
      observer.observe(root);
    });
  }

  function bootLeivasWholesaleSelect() {
    initLeivasWholesaleSelect();
    initLeivasWholesaleSelectReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootLeivasWholesaleSelect);
  } else {
    bootLeivasWholesaleSelect();
  }

  document.addEventListener('shopify:section:load', bootLeivasWholesaleSelect);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-testimonials-section"] && !Shopify.designMode) return;
  try {
    
  function initLeivasWholesaleTestimonials() {
    var roots = document.querySelectorAll('.leivas-wholesale-testimonials [data-reveal-root]');
    if (!roots.length) return;

    if (!('IntersectionObserver' in window)) {
      roots.forEach(function (root) { root.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    roots.forEach(function (root) {
      if (root.dataset.wholesaleTestimonialsBound === 'true') return;
      root.dataset.wholesaleTestimonialsBound = 'true';
      observer.observe(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLeivasWholesaleTestimonials);
  } else {
    initLeivasWholesaleTestimonials();
  }

  document.addEventListener('shopify:section:load', initLeivasWholesaleTestimonials);

  } catch(e) { console.error(e); }
})();
})();
